import { POINTS_LEVEL } from '$lib/session/points'
import type { TypedSupabaseClient } from '$lib/supabase'
import type { Accessory, Profile } from '$lib/types'
import {
  reloadProfile,
  updateProfileLocally,
} from './session-profile-helpers.svelte'

export const updateProfile = async (
  supabase: TypedSupabaseClient,
  userId: string,
  { username }: { username?: string },
) => {
  const update: { username?: string } = {}
  if (username) update.username = username
  updateProfileLocally(update)

  const { error } = await supabase
    .from('profiles')
    .update(update)
    .eq('id', userId)
  if (error) throw error.message

  reloadProfile()
}

export const selectAccessory = async (
  supabase: TypedSupabaseClient,
  userId: string,
  accessory: Pick<Accessory, 'id' | 'type'>,
) => {
  const update: Partial<
    Pick<Profile, 'accessory_head' | 'accessory_body' | 'accessory_pose'>
  > = {}

  switch (accessory.type) {
    case 'head':
      update.accessory_head = accessory.id
      break
    case 'body':
      update.accessory_body = accessory.id
      break
    case 'pose':
      update.accessory_pose = accessory.id
      break
    default:
      throw `Unsupport accessory type ${accessory.type}`
  }
  updateProfileLocally(update)

  const { error } = await supabase
    .from('profiles')
    .update(update)
    .eq('id', userId)
    .single()

  if (error) {
    console.warn(error)
  }

  reloadProfile()
}

export const deselectAccessory = async (
  supabase: TypedSupabaseClient,
  userId: string,
  accessoryType: Accessory['type'],
) => {
  const update: Partial<
    Pick<Profile, 'accessory_head' | 'accessory_body' | 'accessory_pose'>
  > = {}

  switch (accessoryType) {
    case 'head':
      update.accessory_head = null
      break
    case 'body':
      update.accessory_body = null
      break
    case 'pose':
      update.accessory_pose = null
      break
    default:
      throw `Unsupport accessory type ${accessoryType}`
  }
  updateProfileLocally(update)

  const { error } = await supabase
    .from('profiles')
    .update(update)
    .eq('id', userId)
    .single()
  if (error) {
    console.warn(error)
  }
  reloadProfile()
}

export const xpInfo = (xp: number) => {
  const level = Math.trunc(xp / POINTS_LEVEL) + 1
  const tier = Math.floor(Math.log10(level))
  const tierLevel = level < 10 ? level : Math.floor(level / 10 ** tier)

  return {
    level,
    tier,
    tierLevel,
  }
}
